"use client";
import { CATEGORY_COLORS } from "../constants";

const TEXT = "#EDEDED";
const TEXT_MUTED = "#a0a0a0";
const TEAL = "#4FCDC4";

/**
 * Shared related-post card. Same pattern that lives at the bottom of every
 * blog post ("Keep Reading" section); also reused on platform pages by
 * PlatformPageTemplate's relatedPosts prop. CSS hover lives in globals.css
 * via .related-post-card class — no JS event handlers.
 *
 * Takes scalar props (not the full post object) because this is a "use client"
 * component and the post objects in /blog/posts include a `Content: function`
 * field that fails the server→client serialization boundary.
 */
export default function RelatedPostCard({ slug, title, category, readTime }) {
  const color = CATEGORY_COLORS[category] || TEAL;
  return (
    <a href={`/blog/${slug}`} style={{ textDecoration: "none" }}>
      <div className="related-post-card" style={{
        padding: 24, borderRadius: 14,
        background: "rgba(255,255,255,0.02)",
      }}>
        <span style={{
          display: "inline-block", padding: "3px 8px", borderRadius: 5,
          fontSize: 10, fontWeight: 700,
          fontFamily: "var(--mono)", textTransform: "uppercase", letterSpacing: "0.06em",
          background: `${color}18`, color, marginBottom: 10,
        }}>{category}</span>
        <div style={{
          fontFamily: "var(--display)", fontWeight: 700, fontSize: 16,
          color: TEXT, lineHeight: 1.35, marginBottom: 8,
        }}>{title}</div>
        <div style={{ fontSize: 13, color: TEXT_MUTED, fontFamily: "var(--mono)" }}>
          {readTime}
        </div>
      </div>
    </a>
  );
}
